import React from "react";

import Button from "@busbud/design-system-components/dist/Button";
import ExternalLinkMD from "@busbud/design-system-components/dist/Icons/ExternalLink/MD";
import Label from "@busbud/design-system-components/dist/Label";

import { useAppContext } from "@app/helpers/hooks";
import * as WindowUtils from "@app/utils/window";

import { useStyles } from "./submit-claim-button.styles";

interface Props {
  link: string;
}

export const SubmitClaimButton: React.FC<Props> = ({ link }) => {
  const { translator } = useAppContext();
  const { classes } = useStyles();

  const handleNavigate = () => {
    try {
      WindowUtils.openAndFocusOn(link);
    } catch (e) {
      WindowUtils.redirect(link, true);
    }
  };

  return (
    <Button
      className={classes.button}
      size="md"
      fullWidth
      onClick={handleNavigate}
      endIcon={<ExternalLinkMD />}
      data-testid="submit-claim-button"
    >
      <Label size="lg" fontWeight="bold">
        {translator.t("!ancillary.hepstar.submit-claim-button")}
      </Label>
    </Button>
  );
};
